module.exports = __webpack_public_path__ + "static/img/use0.61c0f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/use0.png
// module id = yRN/
// module chunks = 1